export default function PhilosophySection() {
  const principles = [
    {
      title: '以草为灯',
      subtitle: '简朴之道',
      description: '在最朴素的事物中发现光明，以最少的物质获得最大的内心丰盈。草灯虽微，足以照亮前路。',
      icon: 'ri-lightbulb-line',
    },
    {
      title: '以心照路',
      subtitle: '明心见性',
      description: '回归内心，以觉悟之光照亮人生之路。外界的浮华终将褪去，唯有内心的光明永恒不变。',
      icon: 'ri-heart-pulse-line',
    },
    {
      title: '草木有情',
      subtitle: '天人合一',
      description: '与自然和谐共处，在草木之间体悟生命的真谛。每一株草木都是天地大道的显现。',
      icon: 'ri-leaf-line',
    },
    {
      title: '平常心是道',
      subtitle: '日用即禅',
      description: '在日常生活的点滴中修行，将禅意融入举手投足之间。吃饭、喝茶、行走，处处是道场。',
      icon: 'ri-mental-health-line',
    },
  ];

  return (
    <section className="py-16 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <div className="text-center mb-12">
          <p className="text-primary-600 text-sm font-medium tracking-wider mb-3">
            修行哲学
          </p>
          <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 mb-4">
            草灯和尚的精神内核
          </h2>
          <p className="text-foreground-500 max-w-xl mx-auto text-sm leading-relaxed">
            四大核心哲学，引领我们在纷繁世界中找到内心的宁静与力量
          </p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6">
          {principles.map((p) => (
            <div
              key={p.title}
              className="p-6 rounded-lg border border-secondary-200/70 bg-background-50 hover:border-accent-200 transition-all duration-300"
            >
              <div className="w-11 h-11 flex items-center justify-center rounded-full bg-accent-100 text-accent-600 mb-5">
                <i className={`${p.icon} text-lg`}></i>
              </div>
              <p className="text-xs text-accent-600 font-medium mb-2">{p.subtitle}</p>
              <h3 className="text-lg font-heading font-semibold text-foreground-900 mb-3">{p.title}</h3>
              <p className="text-sm text-foreground-500 leading-relaxed">{p.description}</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}